(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('CustomerSearch', CustomerSearch);

  CustomerSearch.$inject = ['$resource', 'API_URI'];

  function CustomerSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/customers/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      /**
       * GET api/merchant-dashboard/customers/search
       *
       * Expected response structure:
       * - Body: a JSON array of Customer objects (not wrapped). For example:
       *   [
       *     {
       *       "id": 123,
       *       "legalName": "John Doe",
       *       "email": "john@example.com",
       *       // ...other customer fields
       *     }
       *   ]
       *
       * Pagination and metadata:
       * - RFC 5988/8288 HTTP Link header is provided by the server to expose pagination links
       *   (rel="first", rel="prev", rel="next", rel="last"). The UI parses this header via
       *   ParseLinks.parse(headers('Link')) to derive page indexes.
       * - X-Total-Count header contains the total number of matching elements across all pages.
       *
       * Notes:
       * - HATEOAS is NOT expected in the response body for this endpoint. The client only consumes
       *   the plain array payload plus the Link and X-Total-Count headers for pagination.
       */
      'getCustomerSearch': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/customers/search',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
    });
  }
})();
